import { PageHero } from "@/components/PageHero";
import { EventsStrip } from "@/components/EventsStrip";

const NEWSLETTERS = [
  { issue: "Issue 24", date: "January 2026", title: "A green start — sustainability wins of 2025", cover: "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?auto=format&fit=crop&w=900&q=80" },
  { issue: "Issue 23", date: "December 2025", title: "Carols, food and the joy of being neighbours", cover: "https://images.unsplash.com/photo-1543599538-a6c4f6cc5c05?auto=format&fit=crop&w=900&q=80" },
  { issue: "Issue 22", date: "October 2025", title: "Festival diaries: Navratri to Halloween", cover: "https://images.unsplash.com/photo-1604607300893-26ee61c3a52a?auto=format&fit=crop&w=900&q=80" },
];

const GROUPS = [
  { name: "Exente Runners", desc: "Daily 5K runs around the 600m loop, dawn or dusk.", color: "bg-brand-leaf/15" },
  { name: "Book Club", desc: "Monthly reads & meets at the Aristotle Library.", color: "bg-brand-gold/15" },
  { name: "Pet Parents", desc: "Walks, vet recommendations and Saturday play-dates.", color: "bg-brand-leaf/15" },
  { name: "Senior's Circle", desc: "Yoga, bhajans, board-games and Wednesday teas.", color: "bg-brand-gold/15" },
  { name: "Kids' Theatre", desc: "Drama workshops led by resident volunteers.", color: "bg-brand-leaf/15" },
  { name: "Sustainability Squad", desc: "Composting, terrace gardening and tree drives.", color: "bg-brand-gold/15" },
];

const Community = () => (
  <div data-testid="community-page">
    <PageHero
      overline="Community Corner"
      title={
        <>
          Where Exente
          <span className="italic text-brand-gold"> comes alive.</span>
        </>
      }
      lead="Events, newsletters and resident-led groups — collaborate, showcase, and stay in the know."
      image="https://images.unsplash.com/photo-1517457373958-b7bdd4587205?auto=format&fit=crop&w=1600&q=80"
    />

    <EventsStrip />

    <section className="py-24 md:py-32 px-6 md:px-10 bg-brand-ivory">
      <div className="max-w-6xl mx-auto">
        <h2 className="font-display text-4xl sm:text-5xl text-brand-forest mb-3">
          Resident groups
        </h2>
        <p className="text-brand-mute mb-12 max-w-2xl">
          Find your tribe. New groups are welcomed — just reach out to the cultural committee.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {GROUPS.map((g, i) => (
            <div
              key={g.name}
              data-testid={`group-${i}`}
              className={`p-8 rounded-2xl ${g.color} border border-brand-sage hover:-translate-y-1 transition-transform duration-500`}
            >
              <h3 className="font-display text-2xl text-brand-forest">{g.name}</h3>
              <p className="text-brand-mute mt-3 leading-relaxed">{g.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    <section className="py-24 md:py-32 px-6 md:px-10 bg-brand-sage/40">
      <div className="max-w-6xl mx-auto">
        <h2 className="font-display text-4xl sm:text-5xl text-brand-forest mb-3">
          Newsletters
        </h2>
        <p className="text-brand-mute mb-12 max-w-2xl">
          A monthly note from the cultural committee, chronicling life at Exente.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {NEWSLETTERS.map((n, i) => (
            <article
              key={n.issue}
              data-testid={`newsletter-${i}`}
              className="bg-brand-ivory rounded-2xl overflow-hidden hover:-translate-y-1 transition-transform duration-500"
            >
              <div className="h-52 overflow-hidden">
                <img src={n.cover} alt={n.title} className="w-full h-full object-cover" />
              </div>
              <div className="p-7">
                <div className="text-xs uppercase tracking-[0.2em] text-brand-leaf font-semibold">
                  {n.issue} · {n.date}
                </div>
                <h3 className="font-display text-2xl text-brand-forest mt-2">{n.title}</h3>
                <a
                  href="#"
                  className="mt-5 inline-block text-sm font-medium text-brand-forest border-b border-brand-gold pb-1 hover:text-brand-gold"
                >
                  Read newsletter →
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  </div>
);

export default Community;
